import { Component, OnInit } from "@angular/core";

@Component({
  moduleId: module.id.toString(),
  selector: "my-not-found",
  template: require('./not-found.component.html')
})
export class NotFoundComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/not-found.component.ts